import { vservice } from '@niknevis/vue-modules'
import { AdminContentItemService } from '@/modules/content-item/services/admin-content-item.service'
import { ContentItemUpdatableAttributesResourceModel } from '@/modules/content-item/models/content-item-resource.model'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'

@vservice()
export class AdminContentItemUpdateAttributesUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminContentItemService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(campaignId: number, data: ContentItemUpdatableAttributesResourceModel) {
    return this.service.update(campaignId, data)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}
